import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

// Generate unique user ID using browser fingerprinting
function generateUserId() {
  const stored = localStorage.getItem('enteeon_user_id');
  if (stored) return stored;
  
  const id = `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  localStorage.setItem('enteeon_user_id', id);
  return id;
}

export const userId = generateUserId();

// Track page views
export const trackPageView = async (pagePath, pageTitle) => {
  try {
    await addDoc(collection(db, 'analytics_events'), {
      eventType: 'page_view',
      page: pagePath,
      pageTitle: pageTitle || document.title,
      timestamp: serverTimestamp(),
      userId,
      userAgent: navigator.userAgent,
      referrer: document.referrer,
    });
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

// Track blog views
export const trackBlogView = async (blogSlug, blogTitle) => {
  try {
    await addDoc(collection(db, 'analytics_events'), {
      eventType: 'blog_view',
      blogSlug,
      blogTitle,
      page: `/blog/${blogSlug}`,
      timestamp: serverTimestamp(),
      userId,
      userAgent: navigator.userAgent,
    });
  } catch (error) {
    console.error('Error tracking blog view:', error);
  }
};

// Track WhatsApp clicks
export const trackWhatsappClick = async (source = 'unknown') => {
  try {
    await addDoc(collection(db, 'analytics_events'), {
      eventType: 'whatsapp_click',
      source,
      page: window.location.pathname,
      timestamp: serverTimestamp(),
      userId,
      userAgent: navigator.userAgent,
    });
  } catch (error) {
    console.error('Error tracking WhatsApp click:', error);
  }
};

// Track custom events
export const trackEvent = async (eventType, eventData) => {
  try {
    await addDoc(collection(db, 'analytics_events'), {
      eventType,
      ...eventData,
      timestamp: serverTimestamp(),
      userId,
      userAgent: navigator.userAgent,
    });
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};
